import { CanActivateFn } from '@angular/router';

import { environment } from '../../environments/environment';

/**
 * Guard which can be applied to an invalid path which will redirect the user to the login URL
 * @returns
 */
export const InvalidPathGuard: CanActivateFn = () => {
    window.location.href = environment.loginUrl;
    return false;
};
